export const hotkeyMessages = {
  "settings.nav.hotkeys": "Keyboard shortcuts",
  "hotkeys.filter": "Filter shortcuts",
  "hotkeys.resetAll": "Reset all",
  "hotkeys.edit": "Edit",
  "hotkeys.clear": "Clear shortcut",
  "hotkeys.empty": "No shortcut",
  "hotkeys.reset": "Reset",
  "hotkeys.cancel": "Cancel",
  "hotkeys.capture": "Press a key combination",
  "hotkeys.captureFor": "Shortcut for {action}",
  "hotkeys.conflict": "{shortcut} is also assigned to: {actions}",
  "hotkeys.saveFailed": "Could not save keyboard shortcuts. Try again.",
  "hotkeys.noResults": "No shortcuts found.",
  "hotkeys.action.session-new": "New session",
  "hotkeys.action.instance-prev": "Previous app tab",
  "hotkeys.action.instance-next": "Next app tab",
  "hotkeys.action.session-prev": "Previous session",
  "hotkeys.action.session-next": "Next session",
  "hotkeys.action.switch-to-info": "Instance info",
  "hotkeys.action.focus-model": "Open model selector",
  "hotkeys.action.open-agent-selector": "Open agent selector",
  "hotkeys.action.focus-variant": "Select model variant",
  "hotkeys.action.clear-input": "Clear prompt",
  "hotkeys.action.focus-input": "Focus prompt",
  "hotkeys.action.session-abort": "Stop session (press twice)",
  "hotkeys.action.prompt-blur": "Unfocus prompt",
  "hotkeys.action.open-command-palette": "Open command palette",
  "hotkeys.action.new-instance": "New instance",
  "hotkeys.action.close-instance": "Close app tab",
  "hotkeys.action.close-session": "Close session",
  "hotkeys.action.app-tab": "App tab {index}",
  "hotkeys.action.session-tab": "Session tab {index}",
  "hotkeys.action.browse-folder": "Browse for a folder",
  "hotkeys.action.session-search": "Search session history",
  "hotkeys.action.user-message-prev": "Jump to previous user message",
  "hotkeys.action.user-message-next": "Jump to next user message",
  "hotkeys.action.search-next-result": "Next search result",
  "hotkeys.action.search-prev-result": "Previous search result",
  "hotkeys.action.session-background": "Move blocking tools to background",
  "hotkeys.action.prompt-send": "Send prompt",
  "hotkeys.action.prompt-alternate-send": "Send with alternate follow-up behavior",
  "hotkeys.action.prompt-newline": "Insert new line",
  "hotkeys.action.prompt-history-prev": "Previous prompt",
  "hotkeys.action.prompt-history-next": "Next prompt",
  "hotkeys.action.prompt-exit-shell": "Exit shell mode",
  "hotkeys.action.aside-send": "Send side question",
  "hotkeys.action.file-save": "Save file",
  "hotkeys.action.instance-rename": "Rename instance",
  "promptInput.overlay.abortHint": "Press again to stop",
} as const
